import { APIResponse } from "../models/NetworkResponse";

import { getAPI, postAPI } from "./Networking";
export default class PaymentLinksAPI {
  generatePaymentLink = async (
    orderId: number,
    providerId: string,
    percentage: number,
  ): Promise<APIResponse> => {
    try {
      const response = await postAPI(
        `/v5/payment-links/order-id/${orderId}/provider/${providerId}/generate`,
        { percentage },
      );
      return response;
    } catch (error) {
      throw error;
    }
  };

  refreshPaymentLink = async (paymentLinkId: number): Promise<APIResponse> => {
    try {
      const response = await getAPI(
        `/v5/payment-links/id/${paymentLinkId}/refresh`,
      );
      return response;
    } catch (error) {
      throw error;
    }
  };
}
